/**
 * ID de persistencia del tipo de publicación.
 * Prioriza PK (idTipoPublicacion / IdTipoPublicacion) sobre "código" de negocio cuando difieren.
 */
export function resolveTipoPublicacionId(tipo, setTipo) {
    const t = tipo && typeof tipo === 'object' ? tipo : {};
    const pk =
        t.idTipoPublicacion ??
        t.IdTipoPublicacion ??
        t.id ??
        t.Id;
    if (pk != null && pk !== '' && Number.isFinite(Number(pk))) {
        return Number(pk);
    }
    const setId = setTipo?.id;
    if (setId != null && setId !== '' && Number.isFinite(Number(setId))) {
        return Number(setId);
    }
    const codigo = t.codigo ?? t.Codigo;
    if (codigo != null && codigo !== '' && Number.isFinite(Number(codigo))) {
        return Number(codigo);
    }
    return undefined;
}

/** PK de grupo de planes (API .NET suele mandar IdGrupoPlan). */
export function resolveGrupoPlanId(grupo) {
    if (!grupo || typeof grupo !== 'object') return undefined;
    const v = grupo.idGrupoPlan ?? grupo.IdGrupoPlan;
    if (v == null || v === '') return undefined;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : undefined;
}

/**
 * IDs para POST .../AsociarGrupoPlanes.
 * Si `tiposGruposPlanes != null` se usó Redux (incluye [] si el usuario vació la lista).
 * Si es `null`/`undefined`, se toman los grupos del tipo cargados por API.
 */
export function listaIdsGrupoPlanesParaAsociar(tiposGruposPlanes, grupoPlanesDelTipo) {
    const touched = tiposGruposPlanes != null;
    const source = touched
        ? (Array.isArray(tiposGruposPlanes) ? tiposGruposPlanes : [])
        : (Array.isArray(grupoPlanesDelTipo) ? grupoPlanesDelTipo : []);
    const ids = source.map((g) => resolveGrupoPlanId(g)).filter((id) => id != null);
    return ids;
}
